<template>
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 742.746 656.701"
    style="width: 100%; height: 100%"
  >
    <g id="Layer_2-2" data-name="Layer 2">
      <g>
        <circle cx="371.373" cy="328.351" r="328.305" fill="#fff"></circle>
        <circle
          cx="371.373"
          cy="328.351"
          r="328.305"
          fill="#367cff"
          opacity=".1"
        ></circle>
        <g>
          <polygon
            points="158.006 439.86 1 439.384 1.646 226.094 110.212 226.423 158.505 275.01 158.006 439.86"
            fill="#fff"
          ></polygon>
          <polygon
            points="110.212 226.423 110.065 274.863 158.505 275.01 110.212 226.423"
            fill="#367cff"
            opacity=".3"
          ></polygon>
          <path
            d="m159.493,274.95c-.005-.088-.022-.173-.05-.257-.011-.032-.019-.064-.034-.095-.048-.106-.109-.207-.194-.293l-48.293-48.587c-.086-.086-.187-.147-.292-.196-.031-.014-.062-.023-.094-.034-.084-.029-.17-.047-.259-.052-.021-.001-.04-.012-.061-.012l-108.565-.329h-.003c-.264,0-.518.104-.705.291-.188.187-.294.441-.295.707L0,439.381c-.001.552.445,1.001.997,1.003l157.006.476h.003c.264,0,.518-.104.705-.291.188-.187.294-.441.295-.707l.499-164.85c0-.022-.011-.041-.012-.063Zm-48.288-46.109l22.292,22.427,22.598,22.735-45.026-.137.136-45.025ZM2.003,438.387l.64-211.29,106.565.323-.143,47.44c-.001.552.445,1.001.997,1.003l47.44.144-.493,162.85-155.006-.47Z"
            fill="#262626"
          ></path>
        </g>
        <g>
          <polygon
            points="478.084 431.325 263.981 430.676 264.862 139.82 412.909 140.269 478.765 206.525 478.084 431.325"
            fill="#fff"
          ></polygon>
          <polygon
            points="412.909 140.269 412.709 206.325 478.765 206.525 412.909 140.269"
            fill="#367cff"
            opacity=".3"
          ></polygon>
          <path
            d="m479.753,206.465c-.005-.088-.022-.173-.05-.257-.011-.032-.019-.064-.034-.095-.048-.106-.109-.207-.194-.293l-65.856-66.256c-.086-.086-.187-.148-.293-.197-.031-.014-.061-.023-.093-.034-.084-.029-.17-.047-.26-.052-.021-.001-.04-.012-.061-.012l-148.047-.449h-.003c-.264,0-.518.104-.705.291-.188.187-.294.441-.295.707l-.881,290.856c-.001.552.445,1.001.997,1.003l214.104.649h.003c.264,0,.518-.104.705-.291.188-.187.294-.441.295-.707l.681-224.8c0-.022-.011-.041-.012-.063Zm-65.851-63.779l62.452,62.832-62.642-.19.19-62.642Zm-148.918,286.993l.875-288.856,146.047.443-.197,65.056c-.001.552.445,1.001.997,1.003l65.056.197-.675,222.8-212.104-.643Z"
            fill="#262626"
          ></path>
        </g>
        <g>
          <polygon
            points="741.247 439.86 584.241 439.384 584.887 226.094 693.453 226.423 741.746 275.01 741.247 439.86"
            fill="#fff"
          ></polygon>
          <polygon
            points="693.453 226.423 693.306 274.863 741.746 275.01 693.453 226.423"
            fill="#367cff"
            opacity=".3"
          ></polygon>
          <path
            d="m742.734,274.95c-.005-.088-.022-.173-.05-.257-.011-.032-.019-.064-.034-.095-.048-.106-.109-.207-.194-.293l-48.293-48.587c-.086-.086-.187-.147-.292-.196-.031-.014-.062-.023-.094-.034-.084-.029-.17-.047-.259-.052-.021-.001-.04-.012-.061-.012l-108.565-.329h-.003c-.264,0-.518.104-.705.291-.188.187-.294.441-.295.707l-.646,213.29c-.001.552.445,1.001.997,1.003l157.006.476h.003c.264,0,.518-.104.705-.291.188-.187.294-.441.295-.707l.499-164.85c0-.022-.011-.041-.012-.063Zm-48.289-46.109l22.292,22.427,22.597,22.735-45.026-.137.136-45.025Zm-109.201,209.546l.64-211.29,106.565.323-.144,47.44c-.001.552.445,1.001.997,1.003l47.44.144-.493,162.85-155.006-.47Z"
            fill="#262626"
          ></path>
        </g>
        <g>
          <g>
            <g>
              <g>
                <circle
                  cx="317.896"
                  cy="294.33"
                  r="14.988"
                  fill="#292a2e"
                ></circle>
                <circle
                  cx="420.668"
                  cy="294.33"
                  r="14.988"
                  fill="#292a2e"
                ></circle>
              </g>
              <path
                d="m389.376,335.78h-40.189c-.552,0-1-.448-1-1s.448-1,1-1h40.189c.552,0,1,.448,1,1s-.448,1-1,1Z"
                fill="#262626"
              ></path>
            </g>
            <g>
              <ellipse
                cx="302.435"
                cy="330.166"
                rx="13.37"
                ry="7.037"
                fill="#fff"
              ></ellipse>
              <ellipse
                cx="436.129"
                cy="330.166"
                rx="13.37"
                ry="7.037"
                fill="#fff"
              ></ellipse>
            </g>
            <g fill="none" opacity=".4">
              <ellipse
                cx="302.435"
                cy="330.166"
                rx="13.37"
                ry="7.037"
                fill="#367cff"
              ></ellipse>
              <ellipse
                cx="436.129"
                cy="330.166"
                rx="13.37"
                ry="7.037"
                fill="#367cff"
              ></ellipse>
            </g>
          </g>
          <path
            d="m479.087,208.909c-25.706-29.508-61.354-47.243-100.403-49.938-39.04-2.695-76.786,9.97-106.303,35.675-48.956,42.637-63.996,113.524-36.577,172.396,5.445,11.71,12.514,22.715,20.993,32.73l1.803,2.133-134.195,142.415c-3.856,4.097-4.82,10.032-2.437,15.138.732,1.571,1.741,2.972,3.017,4.168,5.48,5.168,14.138,4.909,19.306-.571l134.159-142.389,2.24,1.678c22.537,16.976,49.447,26.982,77.822,28.945,39.04,2.695,76.795-9.979,106.303-35.675,29.508-25.705,47.252-61.354,49.947-100.394,2.696-39.04-9.979-76.795-35.675-106.312Zm8.417,104.428c-2.187,31.757-16.619,60.765-40.629,81.677-21.885,19.056-49.349,29.311-78.098,29.311-2.785,0-5.578-.098-8.381-.295-31.766-2.187-60.765-16.619-81.677-40.629-43.155-49.563-37.951-124.993,11.603-168.157,24.01-20.904,54.722-31.212,86.488-29.026,15.878,1.098,31.07,5.248,44.904,12.139,13.835,6.873,26.312,16.485,36.773,28.49,7.417,8.524,13.567,17.976,18.279,28.089,8.417,18.074,12.13,38.264,10.737,58.4Z"
            fill="#367cff"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</template>

<script setup></script>

<style></style>
